<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px">
        <el-form label-width="110px" ref="form" :model="form" :rules="rules">
            <el-form-item label="标签名称" prop="target_label_uuid">
                <LabelSelector v-model="form.target_label_uuid"></LabelSelector>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import LabelSelector from "@/components/LabelSelector";
import { transfer } from "@/api/member/relative";
export default {
    components: { LabelSelector },
    data() {
        return {
            form: {},
            visible: false,
            loading: false,
            options: [],
            title: "",
            rules: {
                target_label_uuid: [{ required: true, message: "请选择标签" }],
            },
            rows: [],
            uuid: "",
        };
    },
    methods: {
        open(rows, uuid, batch) {
            if (batch) {
                this.title = "批量转移";
            } else {
                this.title = "转移";
            }
            this.rows = rows;
            this.uuid = uuid;
            this.visible = true;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                transfer({
                    current_label_uuid: this.uuid,
                    user_uuids: this.rows.map((x) => x.uuid),
                    target_label_uuid: this.form.target_label_uuid,
                }).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("转移成功");
                        this.$emit("update");
                        this.visible = false;
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
